<template>
    <div class="flex flex-col gap-2 pointer-events-none font-oc z-[200]">
        <transition-group name="cz3__toast">
            <div
                v-for="toast in visibleToasts"
                :key="toast.id"
                class="w-full flex items-center rounded border px-4 py-3 shadow-sm bg-black text-white"
                role="status"
                aria-live="polite"
            >
                <div class="pointer-events-auto flex w-full items-start justify-between gap-3 text-[14px] font-oceanside leading-[16px]">
                    <div class="min-w-0 break-words flex items-center w-full">
                        <info-icon v-if="toast.icon === 'info'" class="w-8 h-6 mr-4 text-white" />
                        <div>
                            <span class="font-semibold">
                                {{ toast.message }}
                            </span>
                            <button
                                v-if="toast.linkText && toast.linkAction"
                                type="button"
                                :class="[
                                    'text-white underline ml-1',
                                ]"
                                @click="toast.linkAction"
                            >
                                {{ toast.linkText }}
                            </button>
                        </div>
                        <div
                            v-if="toast.hexColor"
                            class="w-[20px] h-[20px] mx-2 rounded-full shrink-0 border border-white"
                            :style="{ backgroundColor: toast.hexColor }"
                        />
                        <div v-if="toast.messageB">{{ toast.messageB }}</div>
                        <div class="flex-1"></div>
                        <button
                            v-if="toast.dismissible"
                            type="button"
                            :aria-label="$t('COLOR_CHANGE_CONFIRM_CLOSE')"
                            :class="[
                                'focus:outline-none focus:ring-1 focus:ring-white',
                            ]"
                            @click="dismiss(toast.id)"
                        >
                            <img src="../assets/images/icons/cross-white.svg" alt="" class="h-6 w-6 text-white" />
                        </button>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import InfoIcon from './InfoIcon.vue';

    export default {
        mixins: [allStores],

        components: {
            InfoIcon,
        },

        props: {
            anchorName: {
                type: String,
                default: 'top',
            },
            maxVisible: {
                type: Number,
                default: 3,
            },
        },

        computed: {
            visibleToasts() {
                const allToasts = Array.isArray(this.appStore?.toasts)
                    ? this.appStore.toasts
                    : [];
                const filtered = allToasts
                    .filter((toast) => (toast.anchor || 'top') === this.anchorName)
                    .reverse();

                if (this.maxVisible < 1) {
                    return filtered;
                }

                return filtered.slice(0, this.maxVisible);
            },
        },

        methods: {
            dismiss(toastId) {
                this.appStore.dismissToast(toastId);
            },
        },
    };
</script>

<style scoped>
    .cz3__toast-enter-active,
    .cz3__toast-leave-active {
        transition: opacity 0.2s ease, transform 0.2s ease;
    }

    .cz3__toast-enter-from,
    .cz3__toast-leave-to {
        opacity: 0;
        transform: translateY(-6px);
    }
</style>
